import { render, staticRenderFns } from "./ChatGptSettings.vue?vue&type=template&id=06570f10"
import script from "./ChatGptSettings.vue?vue&type=script&lang=js"
export * from "./ChatGptSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports